import { render, staticRenderFns } from "./SessionsByChannel.vue?vue&type=template&id=25cfe00a&"
import script from "./SessionsByChannel.vue?vue&type=script&lang=js&"
export * from "./SessionsByChannel.vue?vue&type=script&lang=js&"
import style0 from "./SessionsByChannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports